import { render } from "./TopNav.vue?vue&type=template&id=683b5a59&scoped=true"
const script = {}

import "./TopNav.vue?vue&type=style&index=0&id=683b5a59&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683b5a59"]])

export default __exports__